export const initCallMeForm = () => {
    const form = document.getElementById('Form_CallMeForm');
    if (!form) return;

    const fieldset = form.querySelector('fieldset');
    const btnToolbar = form.querySelector('.btn-toolbar');

    if (fieldset && btnToolbar) {
        fieldset.appendChild(btnToolbar);
    }
};
